class Filterable {

    constructor(element, params = {}) {

        if (typeof element == 'undefined') {
            return;
        }

        this.element = element;

        if (typeof this.element.data('items-container') == 'undefined' ||
            typeof this.element.data('items') == 'undefined' ||
            typeof this.element.data('type') == 'undefined' ||
            typeof this.element.data('json') == 'undefined' ||
            $(this.element.data('items-container')).length == 0 ||
            $(this.element.data('items')).length == 0){

            return;
        }

        this.textNoResults = '';
        if (typeof this.element.data('no-results') != 'undefined') {
            this.textNoResults = this.element.data('no-results');
        }

        this.data = this.element.data('json');
        this.itemsSelector = this.element.data('items');
        this.itemsContainer = $(this.element.data('items-container'));
        this.type = this.element.data('type');

        let doSearch = false;
        this.hasSearchBar = false;
        if (typeof this.element.data('searchbar') != 'undefined' ||
            $(this.element.data('searchbar')).length != 0) {
            this.searchbarSelector = this.element.data('searchbar');
            this.searchbar = $(this.element.data('searchbar'));
            this.hasSearchBar = true;
            doSearch = true;

            this.searchbar.find('.filter-datepicker').datepicker({
                format: 'dd-mm-yyyy'
            });
        }
        
        this.itemsContainerData = '';

        this.events();

        if (doSearch) {
            this.getAllSearchData();
        }

        this.filter(this.search());
    }

    saveSettings(property, value) {

        $.ajax({
            url: $('body').data('url')+'/backend/functions/module_filterable_save.php?action=1',
            type: 'POST',
            data: {
                type: this.type,
                property: property,
                value: value
            }, 
            success: function(e) {
                console.log(e);
            }
        });
    }

    events() {

        let self = this;

        if (this.hasSearchBar) {

            this.searchbar.find('form').on("keypress", function(e) {
                let code = e.keyCode || e.which;
                if (code == 13) {
                    preventDefault(e);
                    return false;
                }
            });

            this.searchbar.find('.filter-input').each(function() {
       
                if ($(this).is("input:not(.filter-datepicker)")) {
                    $(this).on('keyup paste', function() {
                        self.saveSettings($(this).data('filter-property'), $(this).val());
                        self.setLoading(true);
                        self.filter(self.search());
                    });
                }

                if ($(this).is("select")) {
                    $(this).on('change', function() {
                        self.saveSettings($(this).data('filter-property'), $(this).val());
                        self.setLoading(true);
                        self.filter(self.search());
                    });
                }
                
                if ($(this).is("input.filter-datepicker")) {
    
                    if (typeof $(this).data('sibling') !== 'undefined' ||
                        typeof $(this).data('operator') !== 'undefined' &&
                        typeof self.element.find('#'+$(this).data('sibling')).data('operator') !== 'undefined') {

                        if ($(this).data('operator') == '>' || 
                            $(this).data('operator') == '>=') {
    
                            if ($(this).val() != '') {
                                let date = $(this).val().split('-');
                                $(this).datepicker('setDate', new Date(date[2], date[1] - 1, date[0]));
                            }
  
                            $(this).on('change', function(){
                                $('#'+$(this).data('sibling')).datepicker('option', 'minDate', $(this).datepicker('getDate'));
                            });
                        }
                        if ($(this).data('operator') == '<' || 
                            $(this).data('operator') == '<=') {

                            if ($(this).val() != '') {
                                let date = $(this).val().split('-');
                                $(this).datepicker('setDate', new Date(date[2], date[1] - 1, date[0]));
                            }

                            $(this).on('change', function(){
                                $('#'+$(this).data('sibling')).datepicker('option', 'maxDate', $(this).datepicker('getDate'));
                            });
                        }
                    }

                    $(this).on('change', function() {
                        self.saveSettings($(this).attr('id'), $(this).val());
                        self.setLoading(true);
                        self.filter(self.search());
                    });
                }

            });

            this.searchbar.find('.btn-reset').on('click', function() {
            
                self.searchbar.find('.filter-input').each(function() {
                  
                    if ($(this).is("input:not(.filter-datepicker)")) {
                        $(this).val('');
                    }  

                    if ($(this).is("select")) {
                        $(this).val($(this).data('default-selected'));
                    }   

                    if ($(this).is("input.filter-datepicker")) {
                        $(this).datepicker('setDate', null);
                    }

                });

                self.saveSettings('reset', 'reset');

                self.filter(self.search());
            });
        }

        this.element.find('[data-column]').on('click', function() {
            
            let sort = self.getColumnSorting($(this));
            $(this)
                .removeClass('sort-asc')
                .removeClass('sort-desc')
                .addClass('sort-'+sort);
                
            $(this).siblings('[data-column]')
                .removeClass('sort-asc')
                .removeClass('sort-desc');   

            self.getData(
                $(this).data('column'),
                sort
            );
        });
    }

    getData(name, sort) {

        let self = this;

        this.setLoading(true);

        $.ajax({
            url: $('body').data('url')+'/backend/functions/module_filterable_sort_'+this.type+'.php?action=1',
            type: 'POST',
            data: {
                name: name,
                sort: sort
            },
            success: function(response) {
  
                if (response != 'error') {
                    // response = response.replace(/\|\|1\|\|/gm, '<i class="fas fa-edit"></i></a></div></div></div></div><div class="row row-item" data-id');
                    // response = response.replace(/\|\|2\|\|/gm, '</div><div class="col col-');
                    // response = response.replace(/\|\|3\|\|/gm, 'text-right"><div class="options"><div class="col-12"><a type="button" class="btn-modify" name="modify" href=');
                    self.itemsContainer.html($(response));
                }

                if (self.getAllSearchData().length > 0) {
                    self.filter(self.search());
                }

                self.setLoading(false);
            }
        });

    }

    getColumnSorting(element) {
        return element.hasClass('sort-asc')
            ? 'desc'
            : 'asc';
    }

    getAllSearchData() {
        
        if (!this.hasSearchBar) {
            return [];
        }

        let data = [], 
            add,
            value,
            operator;

        this.searchbar.find('.filter-input').each(function() {

            add = true;
            operator = false;
            value = typeof $(this).val() == 'string'
                ? $(this).val().split(/\s+/).join(' ').trim().toLowerCase()
                : '';

            if ($(this).is("select")) {
                if ($(this).val() == 'all') {
                    add = false;
                }
            } 

            if ($(this).is("input:not(.filter-datepicker)")) {

                if ($(this).val().split(/\s+/).join(' ').trim().length < 2) {
                    add = false;
                }
            } 

            if ($(this).is("input.filter-datepicker") && typeof $(this).data('operator') !== 'undefined') {
                 
                if ($(this).val() == '') {
                    add = false;
                } else {
                    value = $(this).datepicker('getDate').getTime() / 1000;
                    operator = $(this).data('operator');
                    if (operator == '>=') {
                        operator = '>';
                    }
                    if (operator == '<=') {
                        operator = '<';
                    }

                    if (operator == '<') {
                        value += (60 * 60 * 24) - 1;
                    }

                }
            }

            if (add) {
                data.push({
                    data: $(this).data('filter-property'),
                    value: value,
                    operator: operator
                });
            }
        });

        if (data.length > 0) {
            this.searchbar.find('.btn-reset').show();
        } else {
            this.searchbar.find('.btn-reset').hide();
        }

        return data;
    }

    search () {

        let inputData = this.getAllSearchData(),
            filterData = this.data,
            matches = [],
            i = 0, 
            l = filterData.length,
            ii,
            ll = inputData.length,
            m;  

        while (i < l) {
    
            ii = 0;
            m = true;
            while (ii < ll) {
                
                if (inputData[ii].operator === false) {
                    if (!filterData[i][inputData[ii].data].toString().includes(inputData[ii].value)) {
                        m = false;
                        ii = 99;
                    }
                } else {

                    if (inputData[ii].operator == '>'){
                        if (inputData[ii].value > filterData[i][inputData[ii].data]) {
                            m = false;
                            ii = 99;
                        }
                    } else {
                        if (inputData[ii].value < filterData[i][inputData[ii].data]) {
                            m = false;
                            ii = 99;
                        }
                    }
                }
                ++ii;
            }

            if (m) {
                matches.push(parseInt(filterData[i].id));
            }

            ++i;
        }

        return matches;
    }

    filter(matches) {

        this.reset();

        if (matches.length == 0) {

            this.element.find('[data-column]').addClass('sort-disabled');
            
            if (this.itemsContainerData == '') {
                this.itemsContainerData = this.itemsContainer.html();
            }
            this.itemsContainer.html($('<div class="row"><div class="col-12 p-4 text-center font-weight-bold">'+(this.textNoResults == '' ? '&nbsp;' : this.textNoResults)+'</div></div>'));
            
        } else {

            if (this.itemsContainerData != '') {
                this.itemsContainer.html(this.itemsContainerData);
            }
            
            if (matches.length == 1) {
                this.element.find('[data-column]').addClass('sort-disabled');
            } else {
                this.element.find('[data-column]').removeClass('sort-disabled');
            }

            $(this.itemsSelector).each(function() {

                if (!matches.includes($(this).data('id'))) {
                    $(this).hide();
                }
            });
        }

        this.setLoading(false);
    }

    reset() {
        $(this.itemsSelector).each(function() {
            $(this).show();
        });
    }

    setLoading(status = true) {

        this.element.find('.loading').fadeOut(function() {
            $(this).remove();
        });

        if (status) {
            this.element.append('<div class="loading"><i class="fas fa-sync-alt fa-2x fa-spin"></i><span class="sr-only">Loading...</span></div>');
        }
    }
}